var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"form-container bg-white shadow"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v("Forbidden: "+_vm._s(_vm.reason))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }